import VkButton from './vkButton.vue'
export default VkButton
